import { PropsWithChildren } from 'react';
import { useTheme } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import SnackbarAlert from 'components/snackbar/SnackbarAlert';

const NotistackProvider = ({ children }: PropsWithChildren) => {
  const theme = useTheme();

  return (
    <SnackbarProvider
      maxSnack={10}
      style={{ maxWidth: 480 }}
      anchorOrigin={{
        horizontal: theme.direction === 'rtl' ? 'left' : 'right',
        vertical: 'top',
      }}
      Components={{
        default: SnackbarAlert,
        success: SnackbarAlert,
        error: SnackbarAlert,
        warning: SnackbarAlert,
        info: SnackbarAlert,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotistackProvider;
